import { Component, memo } from 'react';
import * as QRCode from 'qrcode';

interface Props {
  data: string;
}

class QrCodeFragment extends Component<Props> {
  componentDidMount(): void {
    const { data } = this.props;

    const generateQRCode = (qrCodeData: string) => {
      QRCode.toCanvas(document.getElementById('qrCodeContainer'), qrCodeData, {}, (error) => {
        if (error) {
          console.error(error);
        }
      });
    };

    generateQRCode(data);
  }

  render(): React.JSX.Element {
    return (
      <div>
        <canvas id="qrCodeContainer" />
      </div>
    );
  }
}

export default memo(QrCodeFragment);
